import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../auth/authContext";
import "./login.css";

export default function LoginPage() {
    const { login } = useAuth();
    const nav = useNavigate();
    const loc = useLocation() as any;
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [message, setMessage] = useState<string | null>("");
    const [busy, setBusy] = useState(false);
    const [err, setErr] = useState<string | null>(null);

    const onSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setBusy(true);
        setErr(null);
        try {
            await login(email, password);
            const to = loc.state?.from?.pathname ?? "/";
            nav(to, { replace: true });
        } catch (e: any) {
            setMessage(`There was an error logging in: ${e?.response?.data.title ?? "Login failed"}`);
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="login-container">
            <form onSubmit={onSubmit}>
                <div className="login-grid">
                    <div>
                        <label className="labelText">Email Address</label>
                        <div>
                            <input type="email" className="inputField" placeholder="Email" value={email} onChange={e => setEmail(e.target.value)} />
                        </div>
                    </div>
                    <div>
                        <label className="labelText">Password</label>
                        <div>
                            <input type="password" className="inputField" placeholder="Password" value={password} onChange={e => setPassword(e.target.value)} />
                        </div>
                    </div>
                    <div>
                        <button disabled={busy} className="btn">{busy ? "Signing in..." : "Sign in"}</button>
                    </div>
                    <div>
                        <span>Don't have an account? </span>
                        <button type="button" className="link-btn" onClick={() => nav("/register")}>Register</button>
                    </div>
                    {err && <div className="text-red-600 text-sm">{String(err)}</div>}
                </div>
            </form>
            <div>{message}</div>
        </div>
    );
}